import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'dcc-spacer',
  template: '',
  styles: [':host { flex: auto; }'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpacerComponent { }
